import {RootState} from "../store";

export const selectCurrentProject = (state: RootState) => state.project.currentProject;
export const selectIsLoadingProject = (state: RootState) => state.project.loading;
export const selectProjectError = (state: RootState) => state.project.error;
export const selectIsPreviewVisible = (state: RootState) => state.project.isPreviewVisible;
export const selectIsPostButtonVisible = (state: RootState) => state.project.isPostButtonVisible;
export const selectIsBodyPromptVisible = (state: RootState) => state.project.isPromptBodyVisible;
export const selectCurrentStep = (state: RootState) => state.project.currentStep;

export const selectScriptData = (state: RootState) => state.project.scriptData;
export const selectIsLoadingScript = (state: RootState) => state.project.loading;
export const selectIsLoadingSharing = (state: RootState) => state.project.isLoadingSharing;